import Link from 'next/link';

export const BreadCrumbs: React.FC<{
  data: { path: string; text: string }[];
}> = ({ data }) => (
  <ul className="tw-flex tw-flex-wrap tw-gap-x-[0.75rem] tw-gap-y-[0.25rem]">
    {data.map(({ path, text }, index) => (
      <li key={index} className="tw-relative tw-min-w-0">
        <Link href={path}>
          <div className="tw-truncate tw-text-base2 tw-text-main-60">
            {text}
          </div>
        </Link>
        {index !== data.length - 1 && (
          <div className="tw-absolute tw-inset-y-0 tw-right-[-0.5rem] tw-my-auto tw-h-[0.3rem] tw-w-[0.3rem] tw-rotate-45 tw-border-r tw-border-t tw-border-r-main-60 tw-border-t-main-40" />
        )}
      </li>
    ))}
  </ul>
);
